import { useTranslation } from 'react-i18next';

export function PasswordFields({
  password,
  repeat,
  onChange,
}: {
  password: string;
  repeat: string;
  onChange: (password: string, repeat: string) => void;
}) {
  const { t } = useTranslation();
  return (
    <>
      <label>
        {t('password.new')}
        <input
          type="password"
          autoComplete="new-password"
          required
          minLength={10}
          value={password}
          aria-describedby="pw-rules"
          onChange={(e) => onChange(e.target.value, repeat)}
        />
      </label>
      <label>
        {t('password.repeat')}
        <input
          type="password"
          autoComplete="new-password"
          required
          value={repeat}
          onChange={(e) => onChange(password, e.target.value)}
        />
      </label>
      <p className="k" id="pw-rules">
        {t('password.rules')}
      </p>
    </>
  );
}
